/* eslint-disable padding-line-between-statements */
import React, { useCallback, useContext,useState, useEffect, useMemo } from 'react';
import { ModalBody, ModalFooter, ModalHeader, ModalNext } from '@jutro/components';
import _ from 'lodash'
import { BreakpointTrackerContext } from '@jutro/layout';
import { TranslatorContext } from '@jutro/locale';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, useDataRefresh, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { TWIAStandardizeButton, TWIAStandardizationStatus } from 'twia-capability-address-component';
import metadata from './AdditionalPremisesCoveragePopup.metadata.json5';
import messages from '../Insureds.messages';

import { Button, CheckboxField, Radio, RadioField } from '@jutro/legacy/components';

function AdditionalPremisesCoveragePopup(props) {

    const {
        title,
        isOpen,
        newAdditionalPremises,
        occupancyTypeList,
        saveData, cancelData, isInvalid, showErrors,
        onResolve,
        // onReject,
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const { refreshData } = useDataRefresh();
    const [displayError, setDisplayError] = useState(false);
    const [modalItem, updateModalItem] = useState(newAdditionalPremises);
    const [zipcodeValidationMessage, setZIPCodeValidationMessage] = useState([]);
    const isUSZIPCode = (code) => /^[0-9]{5}(?:-[0-9]{4})?$/.test(code);
    const { onValidate: setComponentValidation, isComponentValid } = useValidation('AdditionalPremisesCoveragePopup');

    const breakpoint = useContext(BreakpointTrackerContext);
    const errorHandling = useCallback(() => {
        if(!displayError) { setDisplayError(true) }
    }, [displayError] );

    
    const [accountContactVM, updateContactVM] = useState();
    
    const validateZIPCode = useCallback(
        (value, path) => {
            _.set(modalItem, path, value);
            setZIPCodeValidationMessage([]);

            if (!value) {
                setZIPCodeValidationMessage([translator(messages.required)])
            } else if (!isUSZIPCode(value)) {
                setZIPCodeValidationMessage([translator(messages.ZIPCodeValidationMessage)])
            }
            updateModalItem(modalItem);
            refreshData();
        },
        [modalItem, refreshData, translator]);
    
    const writeValue = useCallback(
        (value, path) => {
            _.set(modalItem, path, value);
            updateModalItem(modalItem);
            refreshData();
        }, [modalItem, refreshData]
    );
    
    const onSave = () => {
        if(!isComponentValid) {
            errorHandling();
            isInvalid(isComponentValid, 'AdditionalPremisesCoveragePopup');
        } else {
            saveData(modalItem);
            onResolve();
        }
    };

    const onCancel = () => {
        setDisplayError(false);
        isInvalid(true, 'AdditionalPremisesCoveragePopup');
        cancelData();
        onResolve();
    }

    const resolvers = {
        resolveCallbackMap: {
            OnValidateZIPCode: validateZIPCode,
        },
        resolveComponentMap: {
            // standardizeButtonComponent: TWIAStandardizeButton,
            // standardizeStatusComponent: TWIAStandardizationStatus
        },
    }
    
    const occupancyType = _.get(modalItem, 'occupancy.value')?.code;

    const overrideProps = {
        '@field': {
            // apply to all fields
            showOptional: false,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        occupancy: {
            availableValues: occupancyTypeList
        },
        zipCode: {
            validationMessages: zipcodeValidationMessage
        },
        TFPAPolicyNumber: {
            visible: occupancyType === 'tenant',
            required: occupancyType === 'tenant',
            showRequired: occupancyType === 'tenant',
        },
        medicalPayments: {
            visible: occupancyType === 'tenant',
            required: occupancyType === 'tenant',
            showRequired: occupancyType === 'tenant',
        },
        cancelButtonId: {
            onClick: onCancel
        },
        saveButtonId: {
            onClick: onSave,
            disabled: isComponentValid === false
        },
        // statusComponent: {
        //     primaryAddressVM: primaryAddressVM.value, status:showAddressValidationStatus,
        //     visible: showAddressValidationStatus
        // },
        // buttonComponent: {
        //     primaryAddressVM: primaryAddressVM.value, authHeader
        // },
    }

    return (
        <ModalNext isOpen={isOpen}>
            <ModalHeader title={title} />
            <ModalBody>
                <ViewModelForm
                    uiProps={metadata.pageContent} 
                    overrideProps={overrideProps}
                    model={modalItem}
                    showErrors={showErrors || displayError}
                    onValueChange={writeValue}
                    onValidationChange={setComponentValidation}
                    callbackMap={resolvers.resolveCallbackMap}
                />
            </ModalBody>
        </ModalNext>
    );
}

export default AdditionalPremisesCoveragePopup